import DjangoMessages from 'components/DjangoMessages';
import FormResult from 'components/Form/FormResult';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import PdfReaderPreviewFiles from 'components/PdfReaderPreviewFiles';
import SupersendDetails from 'components/Supersend/components/Details';
import DocumentGroup from 'components/Supersend/components/DocumentGroup';
import MakeLeapsPayments from 'components/Supersend/components/MakeLeapsPayments';
import SendViaClientinbox from 'components/Supersend/components/SendViaClientinbox';
import SendViaClientinboxStatus from 'components/Supersend/components/SendViaClientInboxStatus';
import SendViaPost from 'components/Supersend/components/SendViaPost';
import SendViaPostStatus from 'components/Supersend/components/SendViaPostStatus';
import SendViaSecureSend from 'components/Supersend/components/SendViaSecureSend';
import SendViaSecureSendStatus from 'components/Supersend/components/SendViaSecureSendStatus';
import TeamNotifications from 'components/Supersend/components/TeamNotifications';
import {useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {useBackend} from 'state/backend';

import AttachedDocumentsList from './components/AttachedDocumentsList';
import {SendingOrdersDetailsBackendData} from './types';

const SendingOrdersDetails = () => {
    const methods = useForm();

    const {appPermissions, data, flags} =
        useBackend<SendingOrdersDetailsBackendData>();

    const [isPdfPreviewOpen, setIsPdfPreviewOpen] = useState(false);

    return (
        <FormProvider {...methods}>
            <FormResult />
            <div className="flex flex-col gap-2">
                <DjangoMessages />
                <NavigationTabs.History
                    permissions={appPermissions}
                    selection="sendingOrders"
                />
                <SupersendDetails {...data.supersendMisc} />
                <SendViaClientinboxStatus
                    flags={flags}
                    supersendMid={data.supersendMisc.mid}
                    {...data.sendToClientinbox}
                />
                <SendViaSecureSendStatus
                    supersendMid={data.supersendMisc.mid}
                    {...data.securesend}
                />
                <SendViaPostStatus
                    supersendMid={data.supersendMisc.mid}
                    {...data.sendbypost}
                />
                <DocumentGroup
                    className="mt-4"
                    title={data.supersendMisc.recipientOrganizationDisplayName}
                >
                    <AttachedDocumentsList
                        items={data.documents}
                        onPreviewFiles={() => setIsPdfPreviewOpen(true)}
                    />
                    <TeamNotifications
                        className="mb-4"
                        notificationRecipients={
                            data.supersendMisc.notificationRecipients
                        }
                    />
                    <MakeLeapsPayments
                        className="mb-4"
                        {...data.makeleapsPayments}
                    />
                    <hr className="my-0" />
                    <SendViaClientinbox
                        flags={flags}
                        isSelected={data.sendToClientinbox.isSelected}
                        usersForSendingList={
                            data.sendToClientinbox.usersForSendingList
                        }
                    />
                    <SendViaSecureSend
                        isPasswordProtected={
                            data.supersendMisc.isPasswordProtected
                        }
                        isSelected={data.securesend.isSelected}
                        messagePreview={data.securesend.messagePreview}
                        sendToContacts={data.securesend.sendToContacts}
                    />
                    <SendViaPost
                        contactOrganizationName={
                            data.sendbypost.contactOrganizationName
                        }
                        isSelected={data.sendbypost.isSelected}
                        recipientAddress={data.sendbypost.recipientAddress}
                        recipientContactField={
                            data.sendbypost.recipientContactField
                        }
                        recipientContactHonorific={
                            data.sendbypost.recipientContactHonorific
                        }
                        senderAddress={data.sendbypost.senderAddress}
                        stampType={data.sendbypost.stampType}
                        staticUrl={data.supersendMisc.staticUrl}
                    />
                </DocumentGroup>
                <PdfReaderPreviewFiles
                    isOpen={isPdfPreviewOpen}
                    onClose={() => setIsPdfPreviewOpen(false)}
                    partnerMid={data.supersendMisc.partnerMid}
                    supersendMid={data.supersendMisc.mid}
                />
            </div>
        </FormProvider>
    );
};
export default SendingOrdersDetails;
